exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rate {\n  display: -ms-flexbox;\n  display: flex; }\n\n.rate__item {\n  padding-right: 3px;\n  cursor: pointer; }\n  .rate__item:last-child {\n    padding-right: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/rate/index.scss
// module id = 2830
// module chunks = 69